<template>
    <main-layout class="outil-item bg-gray-100 min-h-screen flex flex-col">

        <!-- Header dégradé -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <app-header icon="tools" class="text-white pt-4 px-4">
                <h1 class="text-2xl flex items-center gap-3">
                    <span>Outillage</span>
                </h1>
            </app-header>

            <!-- Action bar (Retour + action état) -->
            <action-bar :back="{ name: 'liste-outils' }" class="px-4 pb-6">
                <!-- Garde tes classes + ajoute Tailwind ; ne change pas le @click ni le :class -->
                <a href="javascript: void 0"
                    class="btn btn-full main-action inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-lg px-4 py-2 shadow-sm hover:shadow transition text-white"
                    :class="[(outil.actif ? 'actif bg-success' : 'inactif bg-alert')]" @click.prevent="switchOutil">
                    <i :class="outil.actif ? 'icon-valid' : 'icon-error'"></i>
                    <span class="text-sm sm:text-base">
                        Outillage
                        <strong class="ml-1">{{ action }}</strong>
                    </span>
                </a>
            </action-bar>
        </div>

        <!-- Contenu principal -->
        <div class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">
            <div class="m-2 shadow-2xl rounded-xl overflow-hidden mb-8 bg-white">
                <div class="p-4 md:p-6">
                    <!-- Titre section -->
                    <h2 class="text-lg mb-4 uppercase text-secondary">
                        Informations sur votre
                        <b v-if="outil.type_outil" class="font-bold">{{ outil.type_outil.nom }}</b> :
                    </h2>

                    <!-- Formulaire -->
                    <form method="post" id="outil" class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="flex flex-col">
                            <label class="label">Marque</label>
                            <input title="mark" type="text" name="marque" readonly :value="outil.marque"
                                class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">Nom de l'appareil</label>
                            <input title="appareilName" type="text" name="nom" readonly :value="outil.modele"
                                class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">Numéro de série</label>
                            <input title="idNumber" type="text" name="numero" readonly :value="outil.numero_serie"
                                class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">Distributeur</label>
                            <input title="dist" type="text" name="fournisseur" readonly :value="outil.magasin"
                                class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">Date d'achat</label>
                            <input title="buyAt" type="date" name="date_achat" id="date_achat" readonly
                                v-model="dateAchat" class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">N°facture</label>
                            <input title="invoiceNumber" type="text" name="facture_achat" id="facture_achat" readonly
                                v-model="outil.facture_achat" class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">N°bon de livraison</label>
                            <input title="deliveryAt" type="text" name="bon_livraison" id="bon_livraison" readonly
                                v-model="outil.bon_livraison" class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">Dernier contrôle</label>
                            <input title="lastControl" type="date" name="last_controle" id="last_controle" readonly
                                :value="dateLastControle" class="input" />
                        </div>
                    </form>

                </div>
            </div>
        </div>

    </main-layout>
</template>


<script>

import Outil from '../../js/models/Outil'

export default {
    data() {
        return {
            outil: {}
        }
    },

    computed: {
        dateLastControle: function () {
            return moment(this.outil.date_last_controle).format('Y-MM-DD')
        },

        dateAchat() {
            return moment(this.outil.date_achat).format('Y-MM-DD')
        },

        action() {
            if (this.outil.actif === true) {
                return "activé"
            } else {
                return "désactivé"
            }
        }
    },
    props: {},
    methods: {
        getOutil() {
            let vueInstance = this;
            let key = this.$route.params.id;

            Outil
                .getOutil(key)
                .then(res => {
                    vueInstance.outil = res
                })
                .catch()
        },

        switchOutil() {
            if (this.outil.actif === true) {

                this.outil.actif = false;
                Outil.updateOffline(this.outil.id, this.outil)
            } else {
                this.outil.actif = true;

                if (this.outil.type_outil.nom === 'Détecteur de fuites manuel') {
                    Outil
                        .disableDetecteursExcept(this.outil.id)
                        .then(() => {
                            this.$emit('listUpdated')
                        })
                        .catch()
                } else {
                    Outil.updateOffline(this.outil.id, this.outil)
                }
            }
        }
    },

    mounted: function () {
        this.getOutil()


        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }

        yyyy = yyyy + 1;

        let maxDate = yyyy + '-' + mm + '-' + dd;
        document.getElementById('last_controle').setAttribute('max', maxDate)

    },
}

</script>



// WEBPACK FOOTER //
// Outil.vue?108004c5